import {
    ADD_SIZE_ITEM,
    AUTOCOMPLITE_DATA,
    CALC_EMPTY_ERROR,
    CHANGE_SIZE_TYPE,
    CHOSE_TICKET,
    CITY_REPLACE_VALUES,
    CLOSE_REQUEST_POPUP,
    CLOSE_TICKET,
    ERROR_CARGO_NAME,
    ERROR_CARGO_TYPE,
    ERROR_CITY_FROM,
    ERROR_CITY_TO,
    ERROR_DEPARTURE_DATE,
    ERROR_OVERALL_VOLUME_PLACES,
    ERROR_OVERALL_VOLUME_VOLUME,
    ERROR_OVERALL_VOLUME_WEIGHT,
    ERROR_REQUEST_USER_EMAIL,
    ERROR_REQUEST_USER_PHONE,
    ERROR_SIZES,
    GEOLOCATION_DATA,
    HIDE_LOADER,
    REMOVE_SIZE_ITEM,
    REQUEST_ERROR,
    REQUEST_SUCCESS,
    REQUEST_SUCCESS_CLOSE,
    SELECT_CARGO_TYPE_TOGGLE,
    SET_ADV_ADRESS_FINISH_VALUE,
    SET_ADV_ADRESS_FINISH_VALUE_VALUE,
    SET_ADV_ADRESS_START_VALUE,
    SET_ADV_ADRESS_START_VALUE_VALUE,
    SET_ADV_EXPORT_VALUE,
    SET_ADV_IMPORT_VALUE,
    SET_ADV_RAZM_FINISH_VALUE,
    SET_ADV_RAZM_START_VALUE,
    SET_ADV_STRAH_VALUE,
    SET_ADV_STRAH_VALUE_VALUE,
    SET_ADV_TERMINAL_FINISH_VALUE,
    SET_ADV_TERMINAL_START_VALUE,
    SET_CARGO_NAME_VALUE,
    SET_CARGO_TYPE_VALUE,
    SET_CITY_FROM_VALUE,
    SET_CITY_TO_VALUE,
    SET_DEPARTURE_DATE_VALUE,
    SET_OVERALL_VOLUME_PLACES,
    SET_OVERALL_VOLUME_VOLUME,
    SET_OVERALL_VOLUME_WEIGHT,
    SET_SIZE_COUNTER_VALUE,
    SET_SIZE_HEIGHT_VALUE,
    SET_SIZE_LENGTH_VALUE,
    SET_SIZE_WEIGHT_VALUE,
    SET_SIZE_WIDTH_VALUE,
    SET_USER_EMAIL_VALUE,
    SET_USER_PHONE_VALUE,
    SHOW_LOADER,
    SHOW_REQUEST_POPUP,
    TICKETS_REQUEST,
    SET_MAILING,
    SET_PROCESSING,
} from "./types";
import Cookies from "js-cookie";

const hostName = window.location.host;
let domain = "https://scs-aero.ru/";
if (hostName === "test.scs-aero.ru") {
    domain = "https://test.scs-aero.ru/";
} else if (hostName === "scs" || hostName === "localhost:3000") {
    domain = "https://scs/";
}
let now = new Date();
let time = now.getTime();
time += 3600 * 1000;
now.setTime(time);
let expires = now;

export function redirect_to_calc_page() {
    return async (dispatch) => {
        dispatch(hideLoader());
    };
}

export function calc_get_tickets(data) {
    return async (dispatch) => {
        try {
            Cookies.set("calc_redirect", 0, { expires: expires });
            dispatch(showLoader());

            const requestOptions = {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            };
            const response = await fetch(
                domain + "wp-admin/admin-ajax.php?action=calc_get_tickets",
                requestOptions,
            );
            const json = await response.json();
            dispatch({
                type: TICKETS_REQUEST,
                payload: {
                    tickets_error: json.error,
                    tickets_btn: json.btn,
                    course: json.course,
                    export_price: json.export_price,
                    import_price: json.import_price,
                    tickets: json.tickets,
                    totalVolume: json.totalVolume,
                    totalWeight: json.totalWeight,
                    strahProc: json.strahProc,
                    avia: json.avia,
                    commision: json.commision,
                    departure_zone: json.departure_zone,
                    destination_zone: json.destination_zone,
                    is_auto1: json.is_auto1,
                    is_auto2: json.is_auto2,
                    sale_procent: json.sale_procent,
                    totalPaidWeight: json.totalPaidWeight,
                },
            });
            dispatch(hideLoader());
            const ticketsWrapper = document.querySelector("#calc-tickets");
            ticketsWrapper.scrollIntoView();
        } catch (e) {
            dispatch(hideLoader());
        }
    };
}

export function geolocation_load() {
    return async (dispatch) => {
        try {
            if (!(Cookies.get("city_from") !== undefined)) {
                const response = await fetch(
                    domain + "wp-admin/admin-ajax.php?action=get_city_by_ip",
                );
                const json = await response.json();
                if (json) {
                    if (json.city && json.city.length > 0) {
                        Cookies.set("city_from", json.city, {
                            expires: expires,
                        });
                        dispatch({
                            type: GEOLOCATION_DATA,
                            payload: json,
                        });
                    }
                }
            }
        } catch (e) {}
    };
}

export function autocomplite_load() {
    return async (dispatch) => {
        try {
            const response = await fetch(
                domain + "wp-admin/admin-ajax.php?action=city_list",
            );
            const json = await response.json();
            if (json) {
                dispatch({
                    type: AUTOCOMPLITE_DATA,
                    payload: {
                        loaded: true,
                        data: json,
                    },
                });
            }
        } catch (e) {}
    };
}

export function city_field_change(name, value, autocomplite_data) {
    let autocomplite = [];
    if (value.length > 0) {
        for (let i = 0; i < autocomplite_data.length; i++) {
            if (
                autocomplite_data[i]
                    .toUpperCase()
                    .indexOf(value.toUpperCase()) !== -1
            ) {
                let temp_string = autocomplite_data[i];
                if (temp_string.indexOf(",") !== -1) {
                    temp_string = temp_string.split(",")[1];
                }
                autocomplite.push(temp_string.trim());
            }
        }
    }
    if (name === "city_from") {
        return {
            type: SET_CITY_FROM_VALUE,
            payload: { value: value, autocomplite: autocomplite },
        };
    }
    if (name === "city_to") {
        return {
            type: SET_CITY_TO_VALUE,
            payload: { value: value, autocomplite: autocomplite },
        };
    }
    return null;
}

export function city_fields_replacer(val1, val2) {
    return { type: CITY_REPLACE_VALUES, payload: { val1: val2, val2: val1 } };
}

export function date_field_change(name, value) {
    if (value === null) {
        let dep_date = new Date();
        dep_date.setDate(dep_date.getDate() + 1);
        value = dep_date;
    }
    if (name === "departure_date") {
        return { type: SET_DEPARTURE_DATE_VALUE, payload: value };
    }
    return null;
}

export function select_field_toggle(name, value) {
    if (name === "cargo_type") {
        return { type: SELECT_CARGO_TYPE_TOGGLE, payload: !value };
    }
    return null;
}

export function select_change_value(name, value) {
    if (name === "cargo_type") {
        return { type: SET_CARGO_TYPE_VALUE, payload: value };
    }
    return null;
}

export function change_size_type(type) {
    return { type: CHANGE_SIZE_TYPE, payload: type };
}

export function text_field_change(name, value, index) {
    if (name === "overall_volume_places") {
        return { type: SET_OVERALL_VOLUME_PLACES, payload: value };
    }
    if (name === "overall_volume_weight") {
        return { type: SET_OVERALL_VOLUME_WEIGHT, payload: value };
    }
    if (name === "overall_volume_volume") {
        return { type: SET_OVERALL_VOLUME_VOLUME, payload: value };
    }
    if (name === "size_length") {
        return {
            type: SET_SIZE_LENGTH_VALUE,
            payload: { value: value, index: index },
        };
    }
    if (name === "size_width") {
        return {
            type: SET_SIZE_WIDTH_VALUE,
            payload: { value: value, index: index },
        };
    }
    if (name === "size_height") {
        return {
            type: SET_SIZE_HEIGHT_VALUE,
            payload: { value: value, index: index },
        };
    }
    if (name === "size_weight") {
        return {
            type: SET_SIZE_WEIGHT_VALUE,
            payload: { value: value, index: index },
        };
    }
    if (name === "size_counter") {
        let temp = value === "" || isNaN(value) ? 1 : parseInt(value);
        return {
            type: SET_SIZE_COUNTER_VALUE,
            payload: { value: temp, index: index },
        };
    }
    if (name === "adv_strah_value") {
        let temp = value === "" || isNaN(value) ? 0 : parseInt(value);

        return { type: SET_ADV_STRAH_VALUE_VALUE, payload: temp };
    }
    if (name === "adv_adress_start_value") {
        return { type: SET_ADV_ADRESS_START_VALUE_VALUE, payload: value };
    }
    if (name === "adv_adress_finish_value") {
        return { type: SET_ADV_ADRESS_FINISH_VALUE_VALUE, payload: value };
    }
    if (name === "cargo_name") {
        return { type: SET_CARGO_NAME_VALUE, payload: value };
    }
    if (name === "user_phone") {
        return { type: SET_USER_PHONE_VALUE, payload: value };
    }
    if (name === "user_email") {
        return { type: SET_USER_EMAIL_VALUE, payload: value };
    }

    return null;
}

export function checkbox_field_change(name, value) {
    if (name === "adv_export") {
        return { type: SET_ADV_EXPORT_VALUE, payload: !value };
    }
    if (name === "adv_import") {
        return { type: SET_ADV_IMPORT_VALUE, payload: !value };
    }
    if (name === "adv_strah") {
        return { type: SET_ADV_STRAH_VALUE, payload: !value };
    }
    if (name === "adv_terminal_start") {
        return { type: SET_ADV_TERMINAL_START_VALUE, payload: !value };
    }
    if (name === "adv_terminal_finish") {
        return { type: SET_ADV_TERMINAL_FINISH_VALUE, payload: !value };
    }
    if (name === "adv_razm_start") {
        return { type: SET_ADV_RAZM_START_VALUE, payload: !value };
    }
    if (name === "adv_razm_finish") {
        return { type: SET_ADV_RAZM_FINISH_VALUE, payload: !value };
    }
    if (name === "adv_adress_start") {
        return { type: SET_ADV_ADRESS_START_VALUE, payload: !value };
    }
    if (name === "adv_adress_finish") {
        return { type: SET_ADV_ADRESS_FINISH_VALUE, payload: !value };
    }
    if (name === "adv_mailing") {
        return { type: SET_MAILING, payload: !value };
    }
    if (name === "processing") {
        return { type: SET_PROCESSING, payload: !value };
    }

    return null;
}

export function add_size_item() {
    const size = {
        sizeLength: {
            value: "",
        },
        sizeWidth: {
            value: "",
        },
        sizeHeight: {
            value: "",
        },
        sizeVolume: {
            value: "",
        },
        sizeWeight: {
            value: "",
        },
        sizeCounter: {
            value: "1",
        },
    };
    return { type: ADD_SIZE_ITEM, payload: size };
}

export function remove_size_item(index) {
    return { type: REMOVE_SIZE_ITEM, payload: index };
}

export function showLoader() {
    return { type: SHOW_LOADER };
}

export function hideLoader() {
    return { type: HIDE_LOADER };
}

export function choose_ticket(item) {
    if (window.innerWidth < 992) {
        document
            .getElementById("calc-app")
            .scrollIntoView({ behavior: "smooth" });
    } else {
        document.body.classList.add("noscroll");
    }
    return { type: CHOSE_TICKET, payload: item };
}

export function closeTicket() {
    if (window.innerWidth < 992) {
        document
            .getElementById("calc-app")
            .scrollIntoView({ behavior: "smooth" });
    }
    document.body.classList.remove("noscroll");
    return { type: CLOSE_TICKET };
}

export function showRequestPopup() {
    return { type: SHOW_REQUEST_POPUP };
}

export function closeRequestPopup() {
    return { type: CLOSE_REQUEST_POPUP };
}

export function SendRequest(data) {
    console.log(123);
    return async (dispatch) => {
        try {
            console.log(data);
            let send_data = {};
            let places_count = 0;
            let weight = 0;
            let volume = 0;
            let sizes = "";
            let airline = "";
            if (data.sizeType === 1) {
                places_count = parseInt(data.fields.overallVolume.places.value);
                weight = parseFloat(data.fields.overallVolume.weight.value);
                volume = parseFloat(data.fields.overallVolume.volume.value);
            }
            if (data.sizeType === 2) {
                for (let i = 0; i < data.fields.sizes.length; i++) {
                    places_count += parseInt(
                        data.fields.sizes[i].sizeCounter.value,
                    );
                    weight +=
                        parseFloat(data.fields.sizes[i].sizeWeight.value) *
                        parseInt(data.fields.sizes[i].sizeCounter.value);
                    volume += parseFloat(
                        (data.fields.sizes[i].sizeLength.value / 100) *
                            (data.fields.sizes[i].sizeWidth.value / 100) *
                            (data.fields.sizes[i].sizeHeight.value / 100) *
                            data.fields.sizes[i].sizeCounter.value,
                    );
                    sizes +=
                        data.fields.sizes[i].sizeLength.value +
                        " x " +
                        data.fields.sizes[i].sizeWidth.value +
                        " x " +
                        data.fields.sizes[i].sizeHeight.value +
                        " | " +
                        data.fields.sizes[i].sizeWeight.value +
                        " кг х " +
                        data.fields.sizes[i].sizeCounter.value +
                        " \n";
                }
            }

            let summ = data.popup.summ;
            let air_waybill = 0;
            let car_tarif = 0;
            summ += data.advancedOptions.export ? data.export_price : 0;
            summ += data.advancedOptions.import ? data.import_price : 0;
            summ += data.advancedOptions.strah
                ? Math.ceil(
                      parseFloat(data.advancedOptions.strahValue) *
                          parseFloat(data.strahProc),
                  )
                : 0;
            summ +=
                data.advancedOptions.terminalStart &&
                data.popup.departure_terminal
                    ? data.popup.departure_terminal
                    : 0;
            summ +=
                data.advancedOptions.terminalFinish &&
                data.popup.arrival_terminal
                    ? data.popup.arrival_terminal
                    : 0;
            summ += data.advancedOptions.razmStart
                ? data.popup.departure_commission
                : 0;
            summ += data.advancedOptions.razmFinish
                ? data.popup.destination_commission
                : 0;
            air_waybill += data.popup.air_waybill ? data.popup.air_waybill : 0;
            air_waybill += data.popup.air_waybill_t
                ? data.popup.air_waybill_t
                : 0;
            air_waybill += data.popup.air_waybill_l
                ? data.popup.air_waybill_l
                : 0;
            car_tarif += data.popup.car_to_aeroport
                ? data.popup.car_to_aeroport
                : 0;
            car_tarif += data.popup.car_from_aeroport
                ? data.popup.car_from_aeroport
                : 0;
            summ = Math.round(summ * data.commision);

            if (data.popup.path.length > 0) {
                for (let i = 0; i < data.popup.path.length; i++) {
                    if (data.popup.path[i].type === "airline") {
                        airline = data.popup.path[i].airline;
                    }
                }
            }

            send_data.country_from = data.departure_zone;
            send_data.city_from = data.fields.cityFrom.value;
            send_data.country_to = data.destination_zone;
            send_data.city_to = data.fields.cityTo.value;
            send_data.tamog_from = data.advancedOptions.export === true ? 1 : 0;
            send_data.tamog_to = data.advancedOptions.import === true ? 1 : 0;
            send_data.adress_from =
                data.advancedOptions.adressStart === true
                    ? data.advancedOptions.adressStartValue
                    : "";
            send_data.adress_to =
                data.advancedOptions.adressFinish === true
                    ? data.advancedOptions.adressFinishValue
                    : "";
            send_data.cargo_type = data.fields.cargoType.value;
            send_data.cargo_name = data.fields.cargoName.value;
            send_data.strah = data.advancedOptions.strah === true ? 1 : 0;
            send_data.strah_summ =
                data.advancedOptions.strah === true
                    ? data.advancedOptions.strahValue
                    : 0;
            send_data.strah_val = "RUB";
            send_data.places = places_count;
            send_data.weight = weight;
            send_data.volume = volume;
            send_data.sizes = sizes;
            send_data.danger =
                data.fields.cargoType.value === "Опасный груз" ? 1 : 0;
            send_data.date =
                data.fields.departureDate.value.getDate() +
                "-" +
                (data.fields.departureDate.value.getMonth() + 1) +
                "-" +
                data.fields.departureDate.value.getFullYear();
            send_data.terminal_from =
                data.advancedOptions.terminalStart === true
                    ? data.popup.departure_terminal !== undefined
                        ? data.popup.departure_terminal
                        : "Цену уточняйте у менеджера"
                    : "не нужно";
            send_data.razm_from =
                data.advancedOptions.razmStart === true
                    ? data.popup.departure_commission
                    : 0;
            send_data.terminal_to =
                data.advancedOptions.terminalFinish === true
                    ? data.popup.arrival_terminal !== undefined
                        ? data.popup.arrival_terminal
                        : "Цену уточняйте у менеджера"
                    : "не нужно";
            send_data.razm_to =
                data.advancedOptions.razmFinish === true
                    ? data.popup.destination_commission
                    : 0;
            send_data.airfare = data.popup.summ - air_waybill;
            send_data.air_waybill = air_waybill;
            send_data.avto = car_tarif;
            send_data.summ = summ;
            send_data.phone = data.phone;
            send_data.email = data.email;
            send_data.mailing =
                data.advancedOptions.mailing === true ? "Согласен" : "не нужно";
            send_data.processing =
                data.advancedOptions.processing === true ? "Согласен" : "";
            send_data.airline = airline;
            console.log(send_data);
            if (Cookies.get("calc_send_request") === undefined) {
                Cookies.set("calc_send_request", 1, { expires: expires });
                const requestOptions = {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(send_data),
                };
                const response = await fetch(
                    domain + "wp-admin/admin-ajax.php?action=calc_send_request",
                    requestOptions,
                );
                const json = await response.json();
                Cookies.remove("calc_send_request");
                if (json.error && json.error.length > 0) {
                    dispatch({ type: REQUEST_ERROR, payload: json.error });
                } else {
                    const dataFromUIS = {
                        name: "",
                        email: send_data.email,
                        phone: send_data.phone,
                        mailing: send_data.mailing,
                        processing: send_data.processing,
                        message:
                            "country_from: " +
                            send_data.country_from +
                            "\ncity_from: " +
                            send_data.city_from +
                            "\ncountry_to: " +
                            send_data.country_to +
                            "\ncity_to: " +
                            send_data.city_to +
                            "\ntamog_from: " +
                            send_data.tamog_from +
                            "\ntamog_to: " +
                            send_data.tamog_to +
                            "\nadress_from: " +
                            send_data.adress_from +
                            "\nadress_to: " +
                            send_data.adress_to +
                            "\ncargo_type: " +
                            send_data.cargo_type +
                            "\ncargo_name: " +
                            send_data.cargo_name +
                            "\nstrah: " +
                            send_data.strah +
                            "\nstrah_summ: " +
                            send_data.strah_summ +
                            "\nstrah_val: " +
                            send_data.strah_val +
                            "\nplaces: " +
                            send_data.places +
                            "\nweight: " +
                            send_data.weight +
                            "\nvolume: " +
                            send_data.volume +
                            "\nsizes: " +
                            send_data.sizes +
                            "\ndanger: " +
                            send_data.danger +
                            "\ndate: " +
                            send_data.date +
                            "\nterminal_from: " +
                            send_data.terminal_from +
                            "\nrazm_from: " +
                            send_data.razm_from +
                            "\nterminal_to: " +
                            send_data.terminal_to +
                            "\nrazm_to: " +
                            send_data.razm_to +
                            "\nairfare: " +
                            send_data.airfare +
                            "\nair_waybill: " +
                            send_data.air_waybill +
                            "\navto: " +
                            send_data.avto +
                            "\nsumm: " +
                            send_data.summ +
                            "\nairline: " +
                            send_data.airline,
                    };

                    // Отправка данных в UIS
                    // eslint-disable-next-line no-undef
                    Comagic.addOfflineRequest(dataFromUIS);
                    if (typeof window.tgp === "function") {
                        // eslint-disable-next-line no-undef
                        tgp("event", "8tKyQtLB-j9JutXdb");
                    }
                    try {
                        if (window.ym) {
                            window.ym(26965848, "reachGoal", "calc");
                            // eslint-disable-next-line no-undef
                            _tmr.push({
                                type: "reachGoal",
                                id: 3492026,
                                goal: "lead",
                            });
                        }
                    } catch (e) {}
                    dispatch({ type: REQUEST_SUCCESS, payload: json.message });
                }
            } else {
                dispatch({
                    type: REQUEST_ERROR,
                    payload: "Попробуйте отправить заявку позже",
                });
            }
        } catch (e) {}
    };
}

export function closeSuccess() {
    if (window.innerWidth < 992) {
        document
            .getElementById("calc-app")
            .scrollIntoView({ behavior: "smooth" });
    }
    document.body.classList.remove("noscroll");
    return { type: REQUEST_SUCCESS_CLOSE };
}

export function calc_empty_error(errors) {
    return async (dispatch) => {
        try {
            if (errors.length > 0) {
                for (let i = 0; i < errors.length; i++) {
                    if (errors[i] === "cityFrom") {
                        dispatch({ type: ERROR_CITY_FROM });
                    }
                    if (errors[i] === "cityTo") {
                        dispatch({ type: ERROR_CITY_TO });
                    }
                    if (errors[i] === "departureDate") {
                        dispatch({ type: ERROR_DEPARTURE_DATE });
                    }
                    if (errors[i] === "cargoType") {
                        dispatch({ type: ERROR_CARGO_TYPE });
                    }
                    if (errors[i] === "overallVolume_places") {
                        dispatch({ type: ERROR_OVERALL_VOLUME_PLACES });
                    }
                    if (errors[i] === "overallVolume_weight") {
                        dispatch({ type: ERROR_OVERALL_VOLUME_WEIGHT });
                    }
                    if (errors[i] === "overallVolume_volume") {
                        dispatch({ type: ERROR_OVERALL_VOLUME_VOLUME });
                    }
                    if (errors[i] === "sizes") {
                        dispatch({ type: ERROR_SIZES });
                    }
                    if (errors[i] === "cargoName") {
                        dispatch({ type: ERROR_CARGO_NAME });
                    }
                    if (errors[i] === "requestUserPhone") {
                        dispatch({ type: ERROR_REQUEST_USER_PHONE });
                    }
                    if (errors[i] === "requestUserEmail") {
                        dispatch({ type: ERROR_REQUEST_USER_EMAIL });
                    }
                }
            }
            dispatch({ type: CALC_EMPTY_ERROR });
        } catch (e) {}
    };
}

export function show_errors() {}
